import { Money } from '@rabbit/data/types';
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

// TODO : As per the requirement, update the form schema to pass data for Updating the holding and holding proxy
export interface UpdateHoldingProxyRequest {
  holdingLink: string;
  tenantLink: string;
  formData: {
    purchase_price?: Money;
    vendable?: string;
    additionalData?: Record<string, any>;
    purchase_time?: number | undefined;
  };
}
// TODO : As per the requirement, update the form schema to pass data for Updating the holding and holding proxy
export interface UpdateHoldingProxyResponse {
  holdingLink: string;
  holdingProxy: string;
}

export const nestApiGetSingleHoldingProxy = FBF_CloudCallable<
  { holdingProxyLink: string },
  any
>('api/holdingProxies/holdingProxy/:holdingProxyLink|GET');

export const nestApiGetAllHoldingProxies = FBF_CloudCallable<
  { manufacturerLink: string },
  any
>('api/holdingProxies/all/:manufacturerLink|GET');

export const nestApiRegisterInstallerHoldings = FBF_CloudCallable<any, any>(
  'api/holding/registerInstallerHolding/|POST'
);

export const nestApiUpdateHolding = FBF_CloudCallable<
  UpdateHoldingProxyRequest,
  UpdateHoldingProxyResponse
>('api/holding/updateHolding|PUT');

export interface CheckUniqueCodesRequest {
  tenantLink: string;
  mfr?: string;
  uniqueCodes: Record<string, string>;
}

export interface CheckUniqueCodesResponse {
  duplicates: Record<string, { code: string; holdingLinks: string[] }>;
}

export const nestApiCheckHoldingUniqueCodes = FBF_CloudCallable<
  CheckUniqueCodesRequest,
  CheckUniqueCodesResponse
>('api/holding/checkUniqueCodes|POST');
